import {localizeUrl} from '@homeaway/localization-utils';

const PREFER_LOCALE_QUERY_PARAM = 'preferlocale';

export const generateRedirectionUrl = ({path, basePath, currentBasePath, link}) => {
    let url = link;
    if (!url) {
        path = path.substr(currentBasePath.length);
        path = path.indexOf('/') === 0 ? path : `/${path}`;
        url = localizeUrl(path, {basePath});
    }

    let urlPatternWithPreferLocale = new RegExp(`(\\?|\\&)${PREFER_LOCALE_QUERY_PARAM}=`);
    if (!url.match(urlPatternWithPreferLocale)) {
        url = url.includes('?') ? `${url}&${PREFER_LOCALE_QUERY_PARAM}=true` : `${url}?${PREFER_LOCALE_QUERY_PARAM}=true`;
    }

    return url;
};
